// extracted by mini-css-extract-plugin
export default {"container":"Toggle_container__8hNsh","label":"Toggle_label__+QiSX","switch":"Toggle_switch__jSmqS","active":"Toggle_active__zBUkw","toggle":"Toggle_toggle__u8l8O"};